function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M0,0H30V30H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M15.935,2.038a12.989,12.989,0,0,0-13.9,13.9A13.249,13.249,0,0,0,15.4,28h4.8a1.3,1.3,0,0,0,0-2.6H15.428a10.757,10.757,0,0,1-10.5-7.839A10.436,10.436,0,0,1,17.547,4.937,10.726,10.726,0,0,1,25.4,15.428v1.43A2.1,2.1,0,0,1,23.45,18.9a2.1,2.1,0,0,1-1.95-2.041V15.233a6.648,6.648,0,0,0-5.538-6.656A6.507,6.507,0,1,0,19.6,19.6a4.806,4.806,0,0,0,5.59,1.573A4.628,4.628,0,0,0,28,16.832V15.415A13.252,13.252,0,0,0,15.935,2.038ZM15,18.9A3.9,3.9,0,1,1,18.9,15,3.895,3.895,0,0,1,15,18.9Z",
  transform: "translate(0 0)",
  fill: "#797979"
});

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alternate_email-black-18dp",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.7cd658d8.svg";
export { ForwardRef as ReactComponent };